import { css } from '@emotion/react';
// import { focusStyle } from '../../style/shared';

export const occurrenceMap = ({...props}) => css``;

export default {
  occurrenceMap
}